import { Component } from '@angular/core';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-home-export',
  templateUrl: './home-export.component.html',
  styleUrls: ['./home-export.component.scss']
})
export class HomeExportComponent {

  blocs:any;

   responsiveOptions = [
      {
          breakpoint: '1024px',
          numVisible: 3,
          numScroll: 1
      },
      {
          breakpoint: '768px',
          numVisible: 2,
          numScroll: 1
      },
      {
          breakpoint: '560px',
          numVisible: 1,
          numScroll: 1
      }
  ];

  news:any;

  constructor(public api:ApiService) { }

  ngOnInit(){
    this.api.post('site=getNewsPage', { page: 1, nb_items: 4 }).then((res:any) => {
      this.news = res['data'];
      this.api
        .getJson(
          'https://wordpress.blackrockgames.fr/wp-json/wp/v2/posts?categories=9&_embed'
        )
        .then((res2: any) => {
          for (let row of res2) {
            let item = {
              from: 'wp',
              img: row._embedded['wp:featuredmedia']
                ? row._embedded['wp:featuredmedia']['0'].source_url
                : '',
              date_add: row.date,
              slug: row.slug,
              title: row.title.rendered,
            };
            this.news = [...this.news, item];
          }
          this.news = this.news
            .sort((a, b) => b.date_add.localeCompare(a.date_add))
            .slice(0, 4);
        });
    });
    this.blocs = this.api.parse(this.api.stringify(this.api.cats)).filter((cat:any) => {
      cat.games = this.api.games.filter(game => {
        return game.cat_princ == cat.id || game.cats.indexOf(cat.id) > -1;
      }); 
      return true;
    })
  }

}
